import { Fragment, useEffect, useState } from "react";
import { Input, Select, Option } from "@material-tailwind/react";
import countryStates from "../../assets/states.json";
import NextBack from "./NextBack";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  addressForm,
  addressSchema,
} from "../../pages/boat/createBoatValidation";
import ErrorParagraph from "../common/ErrorParagraph";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import { useAddressStore } from "../../store/boat/address";

function Address() {
  const noStateSelected = "Please Select State";
  const [selectedState, setSelectedState] = useState(noStateSelected);
  const { setStepNumber, setOnBoardingPage, setTab } = useOnboardingStore();
  const { setAddress } = useAddressStore();

  const handleStateChange = (value: string | undefined) => {
    if (!value) return;
    console.log(value);
    setSelectedState(value);
    setValue("state", value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<addressForm>({
    resolver: yupResolver(addressSchema),
  });

  const onSubmit = (data: addressForm) => {
    // submit data
    console.log(data);
    setAddress(data);
    setStepNumber(3);
    setTab("Features");
    setOnBoardingPage("Features");
  };

  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <Fragment>
      <form
        className="flex flex-col items-center"
        onSubmit={() => handleSubmit(onSubmit)}
      >
        {/* <div className=" m-2 md:w-1/2 w-full">
          <Select label="Country">
            <Option>Nigeria</Option>
          </Select>
        </div> */}

        <div className=" m-2 md:w-1/2 w-full">
          <Select
            placeholder={undefined}
            value={selectedState}
            {...register("state")}
            onChange={(value) => handleStateChange(value)}
            label="State"
          >
            {countryStates.states.map((state) => (
              <Option key={state} value={state}>
                {state}
              </Option>
            ))}
          </Select>

          {errors.state && (
            <ErrorParagraph message={errors.state.message!}></ErrorParagraph>
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Address 1"
            {...register("address")}
          />
          {errors.address && (
            <ErrorParagraph message={errors.address.message!}></ErrorParagraph>
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Address 2 (Optional)"
            {...register("address2")}
          />
          {errors.address2 && (
            <ErrorParagraph message={errors.address2.message!}></ErrorParagraph>
          )}
        </div>

        {/* <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Postal Code"
            {...register("postalCode")}
          />
          {errors.postalCode && (
            <ErrorParagraph
              message={errors.postalCode.message!}
            ></ErrorParagraph>
          )}
        </div> */}
      </form>
      <NextBack
        shouldGoNext={true}
        next={() => handleSubmit(onSubmit)()}
        back={() => {
          setStepNumber(1);
          setTab("Create");
          setOnBoardingPage("Create");
        }}
      />
    </Fragment>
  );
}

export default Address;
